/**
 * @packageDocumentation
 * @module api.functional.admin.users.alerts
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { ServiceResponseRecordstringnumber } from "../../../../structures/ServiceResponseRecordstringnumber";

/**
 * @controller UserController.getAlerts
 * @path GET /admin/users/alerts
 * @accessor api.functional.admin.users.alerts.getAlerts
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function getAlerts(
  connection: IConnection,
): Promise<getAlerts.Output> {
  return PlainFetcher.fetch(connection, {
    ...getAlerts.METADATA,
    template: getAlerts.METADATA.path,
    path: getAlerts.path(),
  });
}
export namespace getAlerts {
  export type Output = ServiceResponseRecordstringnumber;

  export const METADATA = {
    method: "GET",
    path: "/admin/users/alerts",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = () => "/admin/users/alerts";
}
